(function () {
  // Select all elements with the specific Shopify class
  const sections = document.querySelectorAll(".shopify-section");

  sections.forEach((section) => {
    // Get the computed style to ensure we see the actual rendered color
    const bgColor = window.getComputedStyle(section).backgroundColor;

    // Check for red in both RGB and Hex (just in case)
    if (bgColor === "rgb(17, 23, 37)" || bgColor === "#111725") {
      section.style.backgroundColor = "transparent";
      // console.log("Section updated to transparent:", section);
    }
  });
})();
